export enum PlanSigner {
  SELF = 1,
  FAMILY = 2,
  FAMILY_EXCEPT_SELF = 3,
}

export enum SignEquipment {
  TABLET = 1,
  SMARTPHONE = 2,
}
